$(function () {
    $(document).on('click', '.mousedown_goal', function () {
        var el = $(this);
        g_send_goal(el.data('goal'), el.data('goalCategory'))
    })

    $(document).on('click', '[data-modal]', function (e) {
        var dataTeam = false;
        if ( $(window).innerWidth() < 767 && $(this).hasClass('header__phone')) {
            return;
        }
        e.preventDefault();
        openModal($($(this).data('modal')), $(this), {
            title: $(this).data('title') ? $(this).data('title') : null,
            subtitle: $(this).data('subtitle') ? $(this).data('subtitle') : null,
            image: $(this).data('image') ? $(this).data('image') : null,
            goal: $(this).data('goal') ? $(this).data('goal') : null,
            goalCategory: $(this).data('goal-category') ? $(this).data('goal-category') : null,
        });
    });

    $('.modal__close').click(function () {
        closeModal($(this).parents('.modal'))
    });

    $('.modal').click(function (e) {
        if($(e.target).hasClass('modal')) {
            closeModal($(this));
        }
    });

    $(document).on('closeModal', function (e, data) {
        closeModal(data.modal);
    });

    function openModal(modal, el, data) {
        if(el !== undefined) {
            modal.find('[data-form]')
                .attr('data-form', el.data('modal-url'))
                .data('new-window', el.data('new-window'))
        }

        if (data) {
            if ( data.title ) {
                modal.find('.form__title').text(data.title);
            }
            if ( data.subtitle ) {
                modal.find('.form__subtitle').text(data.subtitle);
            }
            if ( data.image ) {
                modal.find('.form__img').attr('data-url', 'storage' + data.image);
            }
            if ( data.goal ) {
                modal.find('.form__btn').attr('data-goal', data.goal);
            }
            if ( data.goalCategory ) {
                modal.find('.form__btn').attr('data-goal-category', data.goalCategory);
            }
        } else {
            modal.find('.form__img')
                .attr( 'data-url', modal.find('.form__img').attr('data-original-url') );
        }

        modal.fadeIn(function () {
            $('body').trigger('resize')
        });

        $('body').addClass('no-scroll');

        fast_background.update();
    }

    function closeModal(modal) {
        modal.fadeOut();
        $('body').removeClass('no-scroll');
    }
})
